import React from 'react';
import Search from "../search";
import ListGuides from "../ListGuides";


const Guieds = () => {

    return (
        <>
            <Search/>
            <ListGuides/>
        </>
    )
}

export default Guieds;